import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class CevreTemizlikBildirimAPI extends BaseAPI {
    constructor() {
        const baseUrl =
            environment.API_URL + "CevreTemizlikBildirimListe";
        super(baseUrl);
    }

    getCevreTemizlikBildirimListe(sicilKodu:number, aktifPasif: number, ada?: number, parsel?: number, mahalleKodu?: number, caddeSokakKodu?: number) {
        var request = new CevreTemizlikBildirimRequest(sicilKodu, aktifPasif, ada, parsel, mahalleKodu, caddeSokakKodu);
        return this.post("", request, false);
    }
}
export default new CevreTemizlikBildirimAPI();
class CevreTemizlikBildirimRequest {
    public sicilKodu: number;
    public AktifPasif: number;
    public ada?: number;
    public parsel?: number;
    public mahalleKodu?: number;
    public caddeSokakKodu?: number;

    constructor( sicilKodu:number, aktifPasif: number, ada?: number, parsel?: number, mahalleKodu?: number, caddeSokakKodu?: number) {
        this.sicilKodu = sicilKodu;
        this.AktifPasif = aktifPasif;
        this.ada = ada;
        this.parsel = parsel;
        this.mahalleKodu = mahalleKodu;
        this.caddeSokakKodu = caddeSokakKodu;
    }
}
export { CevreTemizlikBildirimRequest };
